export default "__VITE_ASSET__CXQQzqQK__"